import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
  surgeryInfoApi,
  SurgeryInfoService,
  SurgicalEvent,
  surgicalEventApi
} from '@/modules/surgicalEvent';
import { patchTriageEditable } from '@/modules/appContext';
import { SentryService } from '@ianesthesie-kit/sentry';
import omit from 'lodash/fp/omit';
import { isToday } from 'date-fns';
import { parseDateOrNull } from '@ianesthesie-kit/core';
import { patchDashboardUiState } from '@/modules/ui';

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: surgeryInfoApi.endpoints.surgeryInfo.matchFulfilled,
  effect: (action, api) => {
    const isPreop = SurgeryInfoService.isPreopOrUnknownDate(action.payload);
    api.dispatch(
      patchTriageEditable({
        medicalFields: isPreop,
        emergency:
          isPreop ||
          (!!action.payload.surgeryDate &&
            isToday(parseDateOrNull(action.payload.surgeryDate)!))
      })
    );
    api.dispatch(
      patchDashboardUiState({
        lastPdvCpaDate: action.payload.anesthesiaConsultationDate,
        lastPdvCpaTime: action.payload.anesthesiaConsultationTime
      })
    );
  }
});

let lastActiveSe: SurgicalEvent['id'];

listenerMiddleware.startListening({
  matcher: surgicalEventApi.endpoints.activeSurgicalEvent.matchFulfilled,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  effect: (action, api) => {
    const activeSe = action.payload;
    if (activeSe && activeSe.id !== lastActiveSe) {
      lastActiveSe = activeSe.id;
      const masked = {
        ...omit(['patient', 'patientComments'], activeSe),
        patientId: activeSe.patient.id
      };
      SentryService.getInstance().addBreadcrumb({
        level: 'info',
        message: `Current surgical event: ${activeSe.id}`,
        data: masked
      });
    }
  }
});
